export default __webpack_public_path__ + "static/media/008-Statue of Liberty.fc58100f.svg";